// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16FhB","col":"styles_col__1sh95"};